/**
 * Web Style Import
 *
 */

import './style/dnb-code.scss'
